import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { de } from 'vuetify/locale'

const lightTheme = {
  dark: false,
  colors: {
    primary: '#212121',
    secondary: '#E65100',
    accent: '#FF6D00',
    error: '#D32F2F',
    info: '#1976D2',
    success: '#388E3C',
    warning: '#F57C00',
    background: '#FAFAFA',
    surface: '#FFFFFF',
  },
}

const darkTheme = {
  dark: true,
  colors: {
    primary: '#9E9E9E',
    secondary: '#FF6D00',
    accent: '#FF9100',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    background: '#121212',
    surface: '#1E1E1E',
  },
}

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'de',
    messages: { de },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
    },
    VCard: {
      elevation: 2,
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VDataTable: {
      hover: true,
      itemsPerPage: 25,
    },
  },
})
